// Copyright (c) 2017 Deere & Company

import React, {Component, PropTypes} from 'react';
import Accordion from '../../../../shared/components/accordion';
import DealerHierarchy from '../audit-dealer-hierarchy';
import DealerHierarchyFacet from '../../../shared/state/dealer-hierarchy-facet';
import DealerHierarchyLeadAccount from '@deere/cps-it.warranty-model-factory/lib/dealer-hierarchy-lead-account';
import FacetFooter from '../../../../shared/components/facets/facet-footer/index';
import {FormattedMessage} from 'react-intl';
import TranslatedInput from '../../../../shared/components/translated-input';

function handleFilterInputChange(event) {

    const text = event.target.value;

    this.actions.updateFacetFilterText(text);
    this.actions.updateFilteredTerritories(this.territories, text);

}

function handleDealerHierarchyChange(facets) {

    this.actions.updateDealerHierarchyFacet(facets);

}

function handleOnReset() {

    this.actions.resetDealerHierarchyFacet(this.territories);
    this.actions.updateFacetFilterText('');
    this.actions.updateFilteredTerritories(this.territories, '');

}

function handleOnApply() {

    this.actions.readAudits(this.dealerHierarchyFacet.dealers);

}

class AuditDealerHierarchyFacetAccordion extends Component {

    state = {
        dealerLocationExpanded: false
    };

    onAccordionToggle = accordionName => {

        this.setState({
            [accordionName]: !this.state[accordionName]
        });

    };

    anyFacetsOpen = () =>
        this.state.dealerLocationExpanded

    render() {

        const title = (
            <div className='dealer-hierarchy-facet-title'>
                <FormattedMessage id='DEALER_LOCATIONS'/>
            </div>
        );

        const body = (
            <div>
                <div className='rounded-bar'>
                    <span className='icon-search'/>
                    <TranslatedInput
                        className='rounded-input'
                        onChange={this.props::handleFilterInputChange}
                        placeholder='FILTER_PLACEHOLDER'
                        type='text'
                        value={this.props.facetFilterText}
                    />
                </div>
                <DealerHierarchy
                    filterPlaceholder='FILTER_PLACEHOLDER'
                    onDealerHierarchyChange={this.props::handleDealerHierarchyChange}
                    selectedAccounts={this.props.dealerHierarchyFacet.selectedAccounts}
                    selectedCities={this.props.dealerHierarchyFacet.selectedCities}
                    selectedLeadAccounts={this.props.dealerHierarchyFacet.selectedLeadAccounts}
                    selectedTerritories={this.props.dealerHierarchyFacet.selectedTerritories}
                    territories={this.props.filteredTerritories}
                    useInBuiltFilter={false}
                />
            </div>
        );

        return (
            <section className='dealer-hierarchy-facet-accordion'>
                <Accordion
                    accordionId='dealer-hierarchy-facet-accordion'
                    body={body}
                    onClick={this.onAccordionToggle.bind(this, 'dealerLocationExpanded')}
                    title={title}

                />
                {this.anyFacetsOpen() ?
                    <FacetFooter
                        disabled={this.props.dealerHierarchyFacet.dealers.length === 0}
                        onApply={this.props::handleOnApply}
                        onReset={this.props::handleOnReset}
                    /> : null}
            </section>
        );

    }

}

AuditDealerHierarchyFacetAccordion.displayName = 'AuditDealerHierarchyFacetAccordion';
AuditDealerHierarchyFacetAccordion.propTypes = {
    actions: PropTypes.object.isRequired,
    dealerHierarchyFacet: PropTypes.instanceOf(DealerHierarchyFacet).isRequired,
    facetFilterText: PropTypes.string.isRequired,
    filteredTerritories: PropTypes.arrayOf(PropTypes.instanceOf(DealerHierarchyLeadAccount)).isRequired,
    territories: PropTypes.arrayOf(PropTypes.instanceOf(DealerHierarchyLeadAccount)).isRequired
};

export default AuditDealerHierarchyFacetAccordion;



// WEBPACK FOOTER //
// ./src/tcsm/audits/components/dealer-hierarchy-facet/dealer-hierarchy-facet-accordion.js